import { apiAssetsUrl } from '@/services/config';

export type TThemeState = 'light' | 'dark';

export interface IThemeState {
	[key: string]: TThemeState;
}

const THEME_STATE: IThemeState = {
	DARK: 'dark',
	LIGHT: 'light',
};

export const LOCALSTORAGE_THEME_KEY = '__dc_theme';

export const ICON_PLACEHOLDER = `${apiAssetsUrl}/images/icon-placeholder.svg`;

export default THEME_STATE;
